import { createSelector } from 'reselect';
import { buildTypedMap, isImmutableMap } from 'EmailData/types/immutable';
export const getUser = state => {
  return isImmutableMap(state) ? state.get('user') : buildTypedMap(state.auth.user);
};
export const getScopes = createSelector([getUser], user => {
  return isImmutableMap(user) ? user.get('scopes') : user.scopes;
});
export const createHasScopeSelector = scopeToCheck => createSelector([getScopes], scopes => scopes.indexOf(scopeToCheck) > -1);